module.exports = __webpack_public_path__ + "static/media/sp8.7edcb9ea.JPG";